import React, { useCallback, useState } from 'react';
import FeedbackImpactDetails from './FeedbackImpactDetails';
import FeedbackImpactSummary from './FeedbackImpactSummary';
import { Answer } from './api';
import { SelectedCommentSection } from './SectionButtons';
import { FeedbackCommentProps, FeedbackSectionId, UserType } from './utils';
import {
  IMPACT_SUMMARY_QUESTION_ID,
  INDICATOR_DETAILS_QUESTION_ID,
  INDICATOR_SUMMARY_QUESTION_ID,
} from 'npo/pages/NPOFeedback/utils';
import FeedbackCommentRowRender, {
  StyledCommentRowRender,
} from './FeedbackCommentRowRender';
import { FeedbackApi } from '../api';

export interface SectionCommentRowProps {
  feedbackSectionId: FeedbackSectionId;
  title: string;
  comments: FeedbackCommentProps[];
  className?: string;
}

export interface SectionCommentRowExtendedProps extends SectionCommentRowProps {
  answer: Answer;
  allAnswers: Answer[];
  userName: string;
  userType: UserType;
  reportId: number;
  report: FeedbackApi;
  questionId: number;
  addOrUpdateComment: (
    questionId: number,
    comment: FeedbackCommentProps,
    index?: number,
  ) => unknown;
  reloadReportAnswers?: () => unknown;
  deleteComment: (questionId: number, index: number) => unknown;
  currentUserId?: string;
  currentUserEmail?: string;
  selectedCommentSection: SelectedCommentSection;
}

const SectionCommentRow: React.FC<SectionCommentRowExtendedProps> = ({
  answer,
  allAnswers,
  userName,
  reportId,
  report,
  questionId,
  currentUserId,
  currentUserEmail,
  userType,
  title,
  feedbackSectionId,
  comments,
  className,
  selectedCommentSection,
  addOrUpdateComment,
  reloadReportAnswers,
  deleteComment,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(o => !o);
  }, [setOpen]);

  if (selectedCommentSection === 'commented' && comments.length === 0)
    return null;

  // hide empty answers
  if (!answer.text && !answer.date1 && !answer.date2) return null;

  // if (questionId === INDICATOR_SUMMARY_QUESTION_ID) return null;

  if (questionId === INDICATOR_DETAILS_QUESTION_ID) {
    return null;
    // return (
    //   <StyledCommentRowRender open={open} className={className}>
    //     <FeedbackImpactDetails
    //       reportId={reportId}
    //       title={title}
    //       answer={answer}
    //       comments={comments}
    //       questionId={questionId}
    //       currentUserName={userName}
    //       currentUserId={currentUserId}
    //       currentUserType={userType}
    //       currentUserEmail={currentUserEmail}
    //       commentsLength={comments.length}
    //       handleOpen={handleOpen}
    //       className="row-wrapper"
    //       addOrUpdateComment={addOrUpdateComment}
    //     />
    //   </StyledCommentRowRender>
    // );
  }

  if (questionId === IMPACT_SUMMARY_QUESTION_ID) {
    return (
      <StyledCommentRowRender open={open} className={className}>
        <FeedbackImpactSummary
          reportId={reportId}
          title={title}
          answer={answer}
          comments={comments}
          questionId={questionId}
          currentUserName={userName}
          currentUserId={currentUserId}
          currentUserType={userType}
          currentUserEmail={currentUserEmail}
          commentsLength={comments.length}
          handleOpen={handleOpen}
          className="row-wrapper"
          addOrUpdateComment={addOrUpdateComment}
        />
      </StyledCommentRowRender>
    );
  }

  return (
    <FeedbackCommentRowRender
      open={open}
      report={report}
      questionId={questionId}
      reportId={reportId}
      title={title}
      allAnswers={allAnswers}
      userName={userName}
      userType={userType}
      feedbackSectionId={feedbackSectionId}
      currentUserId={currentUserId}
      currentUserEmail={currentUserEmail}
      className={className}
      answer={answer}
      comments={comments}
      handleOpen={handleOpen}
      deleteComment={deleteComment}
      addOrUpdateComment={addOrUpdateComment}
    />
  );
};

export default SectionCommentRow;
